import classNames from '@sindresorhus/class-names';
import {AppFromBackapi} from '@utils/fetchAppsByPackageNames';
import Image from 'next/image';

import styles from './Pick.module.scss';

export default function Pick({
  pick,
  redesign,
}: {
  pick: AppFromBackapi;
  redesign?: boolean;
}) {
  const hasSpaces = (text: string) => /\s/.test(text);
  return (
    <div className={styles.pick}>
      <Image
        alt=""
        className={classNames(styles.icon, {[styles.icon__redesign]: redesign})}
        src={pick.iconUrl}
        width={70}
        height={70}
      />
      <span
        className={classNames(styles.appName, {
          [styles.singleLine]: !hasSpaces(pick.appName),
        })}
        id={pick.packageName}
      >
        {pick.appName}
      </span>
    </div>
  );
}
